import { useTranslation } from 'react-i18next'
import moment, { isMoment, LongDateFormatKey, Moment, MomentInput } from 'moment-timezone'
import 'moment/min/locales.min'

import { DEFAULT_LANGUAGE_CODE } from '../i18n/i18nextLanguageDetector'

interface LocalizedMoment {
  formatDateTime: (date: MomentInput, format: string, timezone?: string) => string,
  fromNow: (date: MomentInput, timezone: string) => string,
  localDateFormat: (format: LongDateFormatKey) => string,
  toNow: (date: MomentInput, timezone: string) => string,
}

export const useLocalizedMoment = (): LocalizedMoment => {
  const { i18n } = useTranslation()

  const prepareDate = (date?: MomentInput): Moment => {
    let momentDate

    if (isMoment(date)) {
      momentDate = date
      momentDate.locale(i18n.language)

    } else {
      try {
        moment.locale(i18n.language)
      } catch (e) {
        moment.locale(DEFAULT_LANGUAGE_CODE)
      }

      momentDate = moment(date)
    }

    return momentDate
  }

  const formatDateTime = (date: Moment, format: string, timezone?: string): string => {
    const momentDate = prepareDate(date)
    timezone && momentDate.tz(timezone)
    return momentDate.format(format)
  }

  const fromNow = (date: Moment, timezone: string): string => {
    const momentDate = prepareDate(date)
    timezone && momentDate.tz(timezone)
    return momentDate.fromNow()
  }

  const localDateFormat = (format: LongDateFormatKey) => {
    const momentDate = prepareDate()
    return momentDate.creationData().locale.longDateFormat(format)
  }

  const toNow = (date: Moment, timezone: string): string => {
    const momentDate = prepareDate(date)
    timezone && momentDate.tz(timezone)
    return momentDate.toNow()
  }

  return {
    formatDateTime,
    fromNow,
    localDateFormat,
    toNow,
  }
}
